export default {
    // French sets a space before "?"; it is non-breaking (\u00a0) so a narrow screen never wraps the "?" onto a line of its own.
    test: "Bonjour le monde",
    loading: 'Chargement...',
    // Shown under a message the form moves past on its own (phone verified, too many attempts, Flinks retries).
    continuing: 'Un instant…',
    from_prepop_get_loan: 'Continuez avec votre demande pour obtenir votre prêt',
    you_were_referred_by: 'Vous avez été référé par',
    prepop_welcome_kicker: 'Pré-qualifié',
    prepop_welcome_title: 'Vous y êtes presque !',
    prepop_welcome_body: 'Terminez votre demande en moins de <strong>2 minutes</strong> et débloquez votre taux de prêt exclusif.',
    prepop_welcome_trust: 'Sans engagement · 100% sécurisé',
    components: {
        form: {},
        field: {},
        flinks: {
            max_retry_reached: "Nombre maximal de tentatives atteint, passage à l'étape suivante.",
        },
        smsverification: {
            edit_phone: "Modifier le numéro de téléphone",
            verify_code: "Vérifier",
            verified_success: 'Votre numéro de téléphone a été vérifié avec succès !',
            max_attempts_reached: 'Vous avez atteint le nombre maximum de tentatives.',
            verification_code_sent: 'Vous recevrez un code de vérification par SMS, des frais de messagerie ou de données standard peuvent s\'appliquer.',
            new_accounts_must_verify: 'Pour des raisons de sécurité, les nouveaux comptes doivent vérifier leurs numéros de téléphone.',
            last_attempt: 'Il vous reste 1 tentative.',
            sent_sms_to: 'Code SMS envoyé à :',
            resend_code: 'Demander un autre code',
            resend_code_in: 'Vous pouvez demander un autre code dans',
            seconds: 'secondes',
            skip_verification_car_loan: `<small><b class='text-primary'>Important:</b> Vous pouvez sauter cette étape, mais vos options peuvent être limitées.</small>`,
            skip_verification_member_enrollment: `<small><b class='text-primary'>Important:</b> Vous pouvez sauter cette étape en appuyant sur le bouton ci-dessous, mais vous ne pourrez pas créer de compte.</small>`,
            enter_valid_code: "Veuillez entrer un code de vérification valide.",
            enter_valid_phone: "Veuillez entrer un numéro de téléphone valide.",
            enter_valid_phone_ca: "Veuillez entrer un numéro de téléphone canadien valide.",
            enter_valid_phone_us: "Veuillez entrer un numéro de téléphone américain valide.",
            sms_code_could_not_send: "Nous n'avons pas pu envoyer le code SMS au numéro fourni. Veuillez vérifier qu'il est correct et réessayez.",
            sms_code_is_incorrect: "Le code que vous avez fourni est incorrect. Veuillez réessayer.",
            enter_phone: 'Entrez votre numéro de téléphone',
            enter_code: "Entrez le code de vérification",
        }
    },
    validations: {
        invalid_data: 'Veuillez vérifier cette entrée.',
        postal_code_format: 'Entrez un code postal comme H2X 1Y4.',
        zip_code_format: 'Entrez un code ZIP à 5 chiffres, comme 10001.',
        required_choice: 'Veuillez choisir une option.',
        required_field: 'Veuillez remplir ce champ.',
        max_length: 'Cette entrée est trop longue. Veuillez la raccourcir.',
        email_undeliverable: "Nous n'avons pas pu vérifier cette adresse courriel. Vérifiez qu'elle ne contient pas de faute de frappe.",
        email_required: "Entrez une adresse courriel valide, comme nom{'@'}exemple.com.",
        phone_format: 'Entrez un numéro de téléphone à 10 chiffres.',
        phone_canadian: 'Entrez un numéro de téléphone canadien à 10 chiffres.',
        phone_us: 'Entrez un numéro de téléphone américain à 10 chiffres.',
        password: "Le mot de passe doit contenir au moins 8 caractères, une lettre majuscule, une lettre minuscule et un chiffre.",
        password_confirmation: "Les mots de passe ne correspondent pas.",
        email_confirmation: 'Les courriels ne correspondent pas.',
        name: "Utilisez seulement des lettres, des espaces, des traits d'union et des apostrophes.",
        dob: 'Choisissez votre date de naissance. Vous devez avoir 18 ans ou plus.',
        date: 'Choisissez une date dans le calendrier.',
        month_year: "Veuillez sélectionner un mois et une année",
        in_choices: "Veuillez sélectionner l'une des options",
        paydate: 'Choisissez une date de paie entre demain et dans 3 mois.',
        sin: 'Entrez votre NAS à 9 chiffres.',
        invalid_character: 'Veuillez retirer les caractères spéciaux.',
        numeric: 'Entrez des chiffres seulement.',
        car_year: "Entrez l'année du véhicule, par exemple 2018.",
        rate: 'Entrez votre taux en chiffres, par exemple 7 ou 6,99.',
        drivers_license: "Vous devez avoir 18 ans ou plus et posséder un permis de conduire pour pouvoir obtenir un prêt automobile",
        address_required: 'Entrez votre adresse.',
        property_mortgage: 'L\'hypothèque doit être inférieure à la valeur de la propriété'
    },
    steps: {
        titles: {
            requested_amount_business: 'Montant de financement souhaité',
            requested_amount: "Combien souhaitez-vous emprunter\u00a0?",
            requested_amount_debt: 'De combien avez-vous besoin pour consolider vos dettes\u00a0?',
            product_purpose: "Quel est le but du prêt\u00a0?",
            cc_debt_amount: "Montant de la dette sur carte de crédit",
            unsecured_debt_amount: "Montant total des autres dettes non garanties",
            in_credit_situation: "Quel est votre score de crédit estimé\u00a0?",
            income_type: "Sélectionnez votre principale source de revenus",
            income_type_other: "Avez-vous d'autres sources de revenus? <br><small>Cochez tout ce qui s'applique</small>",
            direct_deposit: "Recevez-vous votre revenu par dépôt direct\u00a0?",
            monthly_income: "Sélectionnez votre revenu mensuel",
            monthly_income_input: "Entrez votre revenu mensuel",
            monthly_other_income_input: "Entrez votre revenu mensuel",
            address: "Quelle est votre adresse\u00a0?",
            address_length_months: "Depuis combien de temps êtes-vous à cette adresse\u00a0?",
            address_length_months_current: "Depuis combien de temps êtes-vous à votre adresse actuelle\u00a0?",
            own_home: "Êtes-vous propriétaire\u00a0?",
            living_situation: "Parlez-nous de votre situation de logement",
            dob: "Quelle est votre date de naissance\u00a0?",
            employer_information: "Veuillez entrer vos informations professionnelles",
            employed_months: "Depuis combien de temps êtes-vous à cet emploi\u00a0?",
            pay_frequency: "À quelle fréquence êtes-vous payé\u00a0?",
            pay_date1: "Quelle est votre prochaine date de paiement\u00a0?",
            flinks_personal_loan: "Sélectionnez le compte bancaire sur lequel vous souhaitez que votre argent soit déposé",
            flinks_car_loan: 'Sélectionnez le compte bancaire que vous souhaitez utiliser pour vos paiements',
            flinks_powersports: 'Sélectionnez le compte bancaire que vous souhaitez utiliser pour vos paiements',
            how_to_contact: "Comment pouvons-nous vous joindre\u00a0?",
            phone_verification: 'Vérification du téléphone',
            lets_create_your_account: 'Créons votre compte !',
            create_comparehub_account: 'Voulez-vous créer un compte chez nous\u00a0?',
            citizen_status: 'Sélectionnez votre statut de citoyenneté',
            credit_card_debt_amount: 'Montant de la dette de carte de crédit',
            is_last_step: 'C\'est la dernière étape !',
            wants_equifax_verification: 'Voulez-vous être vérifié avec Equifax pour obtenir votre cote de crédit et votre rapport GRATUITS\u00a0?',
            confirm_information: 'Veuillez confirmer vos informations ci-dessous avant de continuer',
            sms_verification: 'Veuillez confirmer votre numéro de téléphone avec le code de vérification qui sera envoyé à votre téléphone',
            lets_get_you_approved: "Faites-vous approuver !",
            postal_code: 'Entrez votre code postal',

            // car loan application
            car_request_type: 'Sélectionnez le type de voiture que vous souhaitez acheter',
            car_request_monthly_budget: "Quel est votre budget mensuel\u00a0?",
            car_in_credit_situation: "Quelle est votre cote de crédit estimée\u00a0?",
            car_request_sms_verification_code: "Veuillez vérifier votre préférence de véhicule en demandant un code de vérification par SMS",

            // life insurance
            requested_amount_life_insurance: 'Quel montant de couverture désirez-vous?',
            what_province: 'Dans quelle province habitez-vous\u00a0?',
            select_gender: 'Sélectionnez votre genre',
            were_you_born_male_or_female: 'Étiez-vous né homme ou femme\u00a0?',
            title_salutation: 'Salutation',
            what_is_your_name: 'Quel est votre nom\u00a0?',
            do_you_smoke_or_vape: 'Est-ce que vous fumez ou vapotez\u00a0?',

            // powersports
            what_are_you_looking_for: "Qu'est-ce que vous souhaitez acheter\u00a0?",
            requested_amount_powersports: 'Quelle est la valeur de l\'article que vous souhaitez financer\u00a0?',

            // business loan
            business_start_date: 'Date de début d’entreprise (estimée)',
            equity: 'Équité',
            business_assets: 'Actifs de l\'entreprise',
            company_information: 'Informations sur l\'entreprise',
            average_monthly_revenue: 'Revenus mensuels moyens',
            notice_of_assessment: 'Avis de cotisation (NOA)',
            // TODO(review): French drafts for the v2 business form
            purpose_of_funds: 'À quoi serviront les fonds\u00a0?',
            has_business_bank_account: "L'entreprise a-t-elle son propre compte bancaire\u00a0?",
            ownership_percentage: "Quelle part de l'entreprise détenez-vous\u00a0?",
            insolvency_consultation: "Avez-vous déjà consulté un syndic autorisé en insolvabilité ou un conseiller en crédit\u00a0?",
            // TODO(review)
            monthly_mortgage_payment: "Quel est votre paiement hypothécaire mensuel\u00a0?",
            monthly_rent: "Quel est votre loyer mensuel\u00a0?",
            // car refinancing
            lower_car_loan_payments: `<h3 class="my-3 text-center h2">Réduisez vos paiements de prêt auto</h3>`,
            tell_us_about_current_vehicle: 'Parlez-nous de votre véhicule actuel',
            tell_us_about_current_financing: 'Parlez-nous de votre financement auto actuel',
            do_you_have_proof_of_income: 'Avez-vous une preuve de revenu?',
            // debt settlement / credit repair
            financial_profile: 'Passons en revue votre profil financier',
            in_bankruptcy: 'Êtes-vous actuellement en faillite\u00a0?',
            in_dmp: 'Êtes-vous actuellement dans un programme de gestion de dettes\u00a0?',
            in_consumer_proposal: 'Êtes-vous actuellement en proposition de consommateur\u00a0?',
            // asset based
            asset_information: 'Parlez-nous de l\'actif',
            //heloc
            more_information_needed: '<h4 class="text-center col-md-10 mx-auto">Nous avons juste besoin d\'un peu plus d\'informations pour continuer...</h4>'
        },
        textTop: {
            hard_credit_check: `<div class="col-md-12 py-2" style="margin-top:30px;">Pour maximiser vos chances de trouver un prestataire de services, nous vous recommandons d'autoriser notre réseau de fournisseurs à obtenir des rapports de crédit auprès des agences d'évaluation du crédit pour évaluer votre historique de crédit et prendre des décisions d'approbation. En sélectionnant "<b class="text-secondary">Maximiser mes chances d'approbation</b>" le(s) fournisseur(s) correspondant(s) peuvent consulter votre rapport de crédit pour prendre des décisions d'approbation complètes basées sur votre demande et vous pouvez être financé plus rapidement. Sinon, vous acceptez que votre consentement se limite uniquement à une vérification de crédit souple et que vous limitez vos opportunités d'approbation. Votre consentement est valide jusqu'à ce que vous notifiiez au fournisseur correspondant le retrait de votre consentement.</div>`,
            unsecured_debt_amount_definition: `<p class="text-muted my-3 text-center">La dette non garantie fait référence aux prêts sur salaire ou personnels et aux factures de télécommunications, mais exclut les soldes de cartes de crédit, les prêts automobiles et les hypothèques.</p>`,
            create_comparehub_account_benefits: `
                <p>En créant un compte, vous pouvez :
                    <ul>
                        <li>Augmenter vos chances de qualification</li>
                        <li>Suivre l'historique de vos demandes</li>
                        <li>Accélérer les demandes futures</li>
                        <li><b>Obtenez votre cote de crédit Equifax gratuite !</b></li>
                    </ul>
                </p>
                <h6 class="text-center text-dark mt-3">La création de votre compte de cote de crédit gratuite n'affectera pas votre crédit</h6>
            `,
            get_options_with_consent: `<p class="text-muted h5 my-3 text-center">Êtes-vous prêt à recevoir vos recommandations par messages électroniques et à voir vos options de prêt\u00a0?</p>`,
            prequalify_best_providers: `<h6 class="text-center text-dark mt-3">Continuer nous aidera à vous préqualifier avec les meilleurs fournisseurs</h6>`,
        },
        hint: {
            // TODO(review): French draft for the v2 business form
            business_start_date_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">La plupart des prêteurs exigent que l'entreprise soit en activité et génère des revenus depuis au moins 6 mois.</p>`,
            average_monthly_revenue_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Tout ce que votre entreprise encaisse chaque mois, avant dépenses.<span class="d-block mt-1">La plupart des prêteurs exigent au moins <b>10&nbsp;000&nbsp;$</b> de ventes totales vérifiables par mois.</span></p>`,
            business_structure_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;"><b>Société par actions :</b> le nom se termine par Inc., Ltée ou Corp.<br><b>Entreprise individuelle :</b> vous ne vous êtes jamais incorporé (travailleur autonome ou nom d'entreprise enregistré).<br><b>Société en nom collectif :</b> deux propriétaires ou plus, sans incorporation.<span class="d-block mt-1"><em>Vous hésitez\u00a0? Choisissez « Autre / je ne sais pas », cela ne bloquera pas votre demande.</em></span></p>`,
        },
        notice: {
            prepop_contact_greeting: 'Vous êtes à un pas de l\'approbation !<br><small>Confirmez vos informations ci-dessous pour continuer.</small>',
            prepop_confirm_address: 'Assurez-vous que votre adresse est correcte pour que nous puissions vous trouver les meilleures offres',
            prepop_verify_phone: 'Vous y êtes presque ! Vérifiez votre téléphone pour débloquer vos offres de prêt personnalisées',
        },
        textBottom: {
            footer_credit_disclaimer: '<p class="text-muted text-center my-3"><small>En remplissant ce formulaire, j\'autorise le fournisseur de services financiers de confiance avec lequel j\'ai été jumelé à obtenir des rapports de crédit auprès des agences d\'évaluation du crédit pour évaluer mon historique de crédit. Mon consentement est valide jusqu\'à ce que j\'informe le fournisseur correspondant de son retrait.</small></p>',
            flinks_skip: '<div class="text-center col-md-12 py-2" style="margin-top: 30px;"><b class="text-primary">Important:</b> Vous pouvez ignorer cette étape en appuyant sur le bouton ci-dessous, cependant vos chances d"approbation peuvent être impactées.<br><br><small>En fournissant vos informations de connexion bancaire, vous confirmez que vous êtes conscient de toutes les obligations contractuelles avec votre institution financière.</small></div>',
            comparehub_member_pp_tc: `En créant un compte, vous deviendrez membre de CompareHub et aurez accès à des ressources éducatives, des recommandations personnalisées et la possibilité d'obtenir votre cote de crédit Equifax gratuite. Pour plus d'informations, veuillez consulter notre <a href="https://loanscanada.ca/privacy-policy/" target="_blank">Politique de confidentialité</a> et nos <a href="https://loanscanada.ca/terms/" target="_blank">Conditions d'utilisation</a>. Cela n'affecte pas votre cote de crédit.`,
            create_comparehub_account_opt_in: `<p class="text-muted small">En créant un compte, vous deviendrez membre de CompareHub et aurez accès à des ressources éducatives, des recommandations personnalisées et la possibilité d'obtenir votre cote de crédit Equifax gratuite. Pour plus d'informations, veuillez consulter notre <a href="https://loanscanada.ca/privacy-policy/" target="_blank">Politique de confidentialité</a> et nos <a href="https://loanscanada.ca/terms/" target="_blank">Conditions d'utilisation</a>. <b>Cela n'affecte pas votre cote de crédit.</b></p>`,
            consent_text: `<p class="text-muted text-center my-3"><small>En remplissant ce formulaire, j'autorise le fournisseur de services financiers de confiance avec lequel j'ai été jumelé à obtenir des rapports de crédit auprès des agences d'évaluation du crédit pour évaluer mon historique de crédit (cela n'affectera pas votre cote de crédit). Mon consentement est valide jusqu'à ce que j'informe le fournisseur correspondant de son retrait.</small></p>`,
            opt_in_text: `<p class="text-muted text-center my-3"><small>En sélectionnant 'Oui', vous acceptez de recevoir des promotions et des mises à jour de {brand} & CompareHub.</small></p>`,
        },
        textBottomBelowActionButtons: {
            terms_privacy_consent: `
                <p style="font-size:13px; color:#6b7280;">{terms_privacy_consent}</p>
            `,
            credit_history_authorization_1: `
                <p style="font-size:13px; color:#6b7280;">{credit_history_authorization_1}</p>
            `,
            credit_history_authorization_1_car_loan: `
                <p style="font-size:13px; color:#6b7280;">{credit_history_authorization_1_car_loan}</p>
            `,
            credit_history_authorization_1_car_refinancing: `
                <p style="font-size:13px; color:#6b7280;">{credit_history_authorization_1_car_refinancing}</p>
            `,
            credit_history_authorization_1_insurance: `
                <p style="font-size:13px; color:#6b7280;">{credit_history_authorization_1_insurance}</p>
            `
        }
    },
    fields: {
        help: {
            round_rate: 'Arrondissez à un entier (6,99 % → 7).',
        },
        labels: {
            requested_amount: "Combien souhaitez-vous emprunter\u00a0?",
            rent_mortgage_payment: "Paiement du loyer/hypothèque",
            monthly_rent_or_mortgage_payment: "Paiement mensuel de loyer ou d'hypothèque (inscrivez 0 si aucun)",
            property_value: "Valeur de la propriété",
            property_mortgage: "Hypothèque de la propriété",
            first_name: "Prénom",
            last_name: "Nom de famille",
            email_address: "Courriel",
            confirm_email: 'Confirmez votre courriel',
            phone: 'Téléphone',
            phone_number: "Numéro de téléphone",
            employer_name: "Nom de l'employeur",
            job_title: "Profession",
            phone_number_work: "Téléphone professionnel",
            address_civic_number: "Numéro civique",
            address_street: "Rue",
            address_unit_number: "Numéro d'unité",
            address_postal_code: "Code postal",
            address_city: "Ville",
            address_province: "Province",
            password: 'Mot de passe',
            confirm_password: 'Confirmez votre mot de passe',
            dob: 'Quelle est votre date de naissance\u00a0?',
            sin_optional: 'NAS (Optionnel)',
            your_address: 'Votre adresse',
            answer_not_provided: "La réponse n'a pas été fournie.",
            monthly_income: 'Revenue mensuel',
            monthly_income_employment: 'Revenue mensuel d\'emploi',
            monthly_income_pension: 'Revenue mensuel de retraite',
            monthly_other_income: 'Autres revenus mensuels',
            postal_code: 'Code postal',
            zip: 'Code postal',
            address_zip: 'Code postal',
            address_state: 'État',
            state: 'État',
            province: 'Province',
            last_years_income: 'Revenu de l\'année dernière',
            year_before_last_income: 'Revenu de l\'année avant la dernière',
            liquid_equity: `Actifs liquides <br>(argent, actions, obligations, FNB)`,
            non_liquid_equity: `Actifs non liquides <br>(équipement, immobilier, véhicules)`,
            company_name: 'Nom de l\'entreprise',
            gross_sales_monthly: 'Ventes brutes (mensuelles)',
            gross_sales_cards: 'Ventes brutes (cartes seulement)',
            average_monthly_sales: 'Ventes mensuelles moyennes',
            average_monthly_sales_cards: 'Ventes mensuelles moyennes (crédit/débit)',
            industry: 'Industrie',
            payment_processor: 'Quel est votre processeur de paiement\u00a0?',
            business_structure: `Structure juridique de l'entreprise <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" class="text-secondary ms-1 align-text-bottom" style="width: 0.9rem; height: 0.9rem;" role="img" aria-label="Voir la note ci-dessus"><title>Voir la note ci-dessus</title><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>`,
            number_of_employees: 'Nombre d\'employés, vous inclus',
            // car refinancing
            car_ownership_status: 'Statut de possession du véhicule',
            car_value: 'Valeur du véhicule',
            car_refinancing_balance: 'Solde du financement auto',
            car_year: 'Année du véhicule',
            car_mileage: 'Kilométrage (km)',
            car_make: 'Marque du véhicule',
            car_model: 'Modèle du véhicule',
            car_current_lender: 'Prêteur actuel',
            car_current_loan_rate: 'Taux du prêt actuel',
            car_current_loan_monthly_payment: 'Paiement mensuel',
            car_loan_remaining_months: 'Mois restants',
            title_salutation: "Salutation",
            employed_months: "Depuis combien de temps êtes-vous à cet emploi\u00a0?",
            // debt / financial profile
            in_bankruptcy: 'Êtes-vous actuellement en faillite\u00a0?',
            in_dmp: 'Êtes-vous actuellement dans un programme de gestion de dettes\u00a0?',
            in_consumer_proposal: 'Êtes-vous actuellement en proposition de consommateur\u00a0?',
            business_start_date: 'Date de début de l\'entreprise',
            // asset based
            asset_type: 'Type d\'actif',
            asset_type_custom: 'Décrivez votre actif',
            asset_value: 'Valeur de l\'actif',
            asset_financed: 'L\'actif est-il financé\u00a0?',
            asset_financing_amount: 'Montant du financement de l\'actif',
            new_asset_name: 'Décrivez l\'actif',
            new_asset_value: 'Prix d\'achat de l\'actif',
        },
        options: {
            opt_yes: "Oui",
            opt_no: "Non",
            opt_not_right_now: "Pas maintenant",
            //requested_amount
            opt_1000_less: "1 000 $ ou moins",
            opt_1001_5000: "1 001 $ à 5 000 $",
            opt_5001_10000: "5 001 $ à 10 000 $",
            opt_10001_15000: "10 001 $ à 15 000 $",
            opt_15001_20000: "15 001 $ à 20 000 $",
            opt_20000_more: "Plus de 20 000 $",
            opt_20001_50000: "20 001 $ à 50 000 $",
            opt_50000_more: "Plus de 50 000 $",
            opt_amount_1001_2000: "1 001 $ à 2 000 $",
            opt_amount_2001_3000: "2 001 $ à 3 000 $",
            opt_amount_3001_4000: "3 001 $ à 4 000 $",
            opt_amount_4001_5000: "4 001 $ à 5 000 $",
            opt_amount_2001_5000: "2 001 $ à 5 000 $",
            // product_purpose
            opt_debt_consolidation: "Consolidation de dettes",
            opt_cc_consolidation: "Consolidation de cartes de crédit",
            opt_emergency_expense: "Dépense d'urgence",
            opt_car_repair: "Réparation de voiture",
            opt_other: "Autre",
            // cc_debt_amount
            // unsecured_debt_amount
            opt_debt_no_cc_debt: "Aucune dette de carte de crédit",
            opt_debt_no_unsecured_debt: "Aucune autre dette non garantie",
            opt_debt_amounts_2500_less: "Moins de 2 500 $",
            opt_debt_amounts_2501_5000: "2 501 $ à 5 000 $",
            opt_debt_amounts_5001_10000: "5 001 $ à 10 000 $",
            opt_debt_amounts_10001_15000: "10 001 $ à 15 000 $",
            opt_debt_amounts_15001_20000: "15 001 $ à 20 000 $",
            opt_debt_amounts_20001_25000: "20 001 $ à 25 000 $",
            opt_debt_amounts_25000_more: "Plus de 25 000 $",
            // in_credit_situation
            opt_in_credit_situation_good: "Bonne (Plus de 700)",
            opt_in_credit_situation_fair: "Passable (550 - 700)",
            opt_in_credit_situation_low: "Faible (Moins de 550)",
            opt_in_credit_situation_cp: "Proposition de consommateur actuelle",
            opt_in_credit_situation_bk: "Faillite actuelle",
            opt_in_credit_situation_unknown: "Pas sûr",
            // income_type
            opt_income_type_full: "Temps plein",
            opt_income_type_part: "Temps partiel",
            opt_income_type_self: "Travailleur indépendant",
            opt_income_type_benefits: "Prestations familiales / AE",
            opt_income_type_disability: "Invalidité",
            opt_income_type_pension: "Pension / RPC / SV",
            opt_income_type_unemployed: "Sans emploi",
            opt_income_type_other: "Autre",
            //other income types
            opt_income_type_other_wsib: "CSPAAT",
            opt_income_type_other_short_term_disability: "Invalidité de courte durée",
            opt_income_type_other_long_term_disability: "Invalidité de longue durée",
            opt_income_type_other_social_security: "Assurance-emploi",
            opt_income_type_other_child_tax_benefit: "Allocation canadienne pour enfants",
            opt_income_type_other_rental_income: "Revenu locatif",
            opt_income_type_other_other: "Autre",
            opt_income_type_other_none: "Aucun",
            // monthly_income
            opt_1500_less: "1 500 $ ou moins",
            opt_1501_2000: "1 501 $ à 2 000 $",
            opt_2001_3000: "2 001 $ à 3 000 $",
            opt_3001_4000: "3 001 $ à 4 000 $",
            opt_4001_5000: "4 001 $ à 5 000 $",
            opt_5000_more: "Plus de 5 000 $",
            // employed_months
            opt_employed_months_3_less: "Moins de 3 mois",
            opt_employed_months_3_6: "3 à 6 mois",
            opt_employed_months_6_12: "6 à 12 mois",
            opt_employed_months_12_more: "1 an ou plus",
            // pay_frequency
            opt_weekly: "Hebdomadaire",
            opt_bi_weekly: "Bi-hebdomadaire",
            opt_semi_monthly: "Semi-mensuel",
            opt_monthly: "Mensuel",
            // address_length_months
            opt_address_length_months_3_less: "Moins de 3 mois",
            opt_address_length_months_3_6: "3 à 6 mois",
            opt_address_length_months_6_12: "6 à 12 mois",
            opt_address_length_months_12_more: "1 an ou plus",
            // opt_in & credit consent
            opt_opt_in_consent: 'Recevoir des promotions et des mises à jour de {brand} par courriel. Vous pouvez vous désabonner à tout moment. En cliquant sur "Suivant", vous acceptez les <a href="https://loanscanada.ca/terms/" target="_blank">conditions d\'utilisation</a> et la <a href="https://loanscanada.ca/privacy-policy/" target="_blank">politique de confidentialité</a>.',
            opt_opt_in_consent_by_lc: 'Recevoir des promotions et des mises à jour de {brand} par Loans Canada par courriel. Vous pouvez vous désabonner à tout moment. En cliquant sur "Suivant", vous acceptez les <a href="https://loanscanada.ca/terms/" target="_blank">conditions d\'utilisation</a> et la <a href="https://loanscanada.ca/privacy-policy/" target="_blank">politique de confidentialité</a>.',
            opt_opt_in_consent_by_comparehub: 'Recevoir des promotions et des mises à jour de {brand} par CompareHub par courriel. Vous pouvez vous désabonner à tout moment. En cliquant sur "Suivant", vous acceptez les <a href="https://loanscanada.ca/terms/" target="_blank">conditions d\'utilisation</a> et la <a href="https://loanscanada.ca/privacy-policy/" target="_blank">politique de confidentialité</a>.',
            opt_credit_auth_1: "Montrez-moi d'autres options",
            opt_credit_auth_2: "Maximisez mes chances d'approbation",
            // canadian status
            opt_cs_citizen: "Citoyen",
            opt_cs_permanent: "Résident permanent",
            opt_cs_work: "Permis de travail",
            opt_cs_student: "Visa étudiant",
            opt_cs_visitor: "Visiteur",
            opt_cs_other: "Autre",
            // options_opt_in
            opt_continue_with_consent_yes: "Oui, et montrez-moi mes options de prêt !",
            opt_continue_with_consent_no: "Continuez uniquement vers mes options de prêt",
            // car_request_type
            opt_car_type_sedan : 'Berline',
            opt_car_type_suv : 'VUS',
            opt_car_type_van : 'Minivan',
            opt_car_type_truck : 'Camion',
            // car_request_monthly_budget
            opt_car_budget_200_less : 'Jusqu\'à 200 $',
            opt_car_budget_201_350 : '201 $ à 350 $',
            opt_car_budget_351_500 : '351 $ à 500 $',
            opt_car_budget_501_more : '501 $ ou plus',
            // life insurance
            //requested_amount
            opt_100k_less: "100 000 $ ou moins",
            opt_100k_250k: "100 001 $ à 250 000 $",
            opt_250k_500k: "250 001 $ à 500 000 $",
            opt_500k_1m: "500 001 $ à 1 000 000 $",
            opt_1m_more: "Plus de 1 000 000 $",
            // title
            opt_title_male: "Homme",
            opt_title_female: "Femme",
            // powersports
            opt_powersports_rv: "Véhicules récréatifs",
            opt_powersports_boat: "Bateaux",
            opt_powersports_tractor: "Tracteurs de jardin",
            opt_powersports_atv: "VTT (véhicules tout-terrain)",
            opt_powersports_motorcycle: "Motocyclettes",
            opt_powersports_snowmobile: "Motoneiges",
            opt_powersports_ebike: "Vélos électriques",
            opt_powersports_personalwatercraft: 'Motomarines <span style="font-size: 0.75rem; display:block;">(p. ex., Jet Skis, Sea-Doos, bateaux)</span>',
            opt_powersports_camper: "Caravanes",
            opt_powersports_heavyequipment: "Équipements lourds",
            // business loan
            // - business_type "Other" on the POS financing form
            opt_business_type_other: "AUTRE",
            // - business_type, formulaires entreprise et traitement des paiements (15 secteurs) TODO(review)
            opt_business_industry_automotive: "Automobile (réparation, concessionnaire, lave-auto)",
            opt_business_industry_beauty: "Salon de beauté, barbier ou spa",
            opt_business_industry_cannabis: "Boutique de cannabis, de vapotage ou de tabac",
            opt_business_industry_construction: "Construction et métiers",
            opt_business_industry_recreation: "Divertissement, conditionnement physique et loisirs",
            opt_business_industry_health: "Santé et services médicaux",
            opt_business_industry_manufacturing: "Fabrication et commerce de gros",
            opt_business_industry_online_store: "Boutique en ligne / commerce électronique",
            opt_business_industry_professional_services: "Services professionnels et aux entreprises (juridique, comptabilité, finance, assurance, conseil, marketing)",
            opt_business_industry_real_estate: "Immobilier",
            opt_business_industry_restaurant: "Restaurant, café ou bar",
            opt_business_industry_retail: "Commerce de détail",
            opt_business_industry_technology: "Technologie et TI",
            opt_business_industry_transportation: "Camionnage et transport",
            opt_business_industry_other: "Autre",
            // - business_structure (explications dans steps.hint.business_structure_hint)
            opt_business_structure_corporation: "Société par actions",
            opt_business_structure_sole_proprietorship: "Entreprise individuelle",
            opt_business_structure_general_partnership: "Société en nom collectif",
            opt_business_structure_limited_partnership: "Société en commandite (SEC)",
            opt_business_structure_non_profit: "OBNL ou organisme de bienfaisance",
            opt_business_structure_other: "Autre / je ne sais pas",
            // - ownership_percentage
            opt_ownership_percentage_100: "Je suis le seul propriétaire",
            opt_ownership_percentage_51: "Plus de la moitié",
            opt_ownership_percentage_50: "Exactement la moitié",
            opt_ownership_percentage_1: "Moins de la moitié",
            // - rent_mortgage_payment (montants représentatifs; propriétaires et locataires voient des tranches différentes) TODO(review)
            opt_rent_mortgage_payment_0_owner: "Aucune hypothèque, la maison est payée",
            opt_rent_mortgage_payment_0_renter: "Je ne paie pas de loyer",
            opt_rent_mortgage_payment_250: "Moins de 500 $",
            opt_rent_mortgage_payment_625: "500 $ à 749 $",
            opt_rent_mortgage_payment_750: "500 $ à 999 $",
            opt_rent_mortgage_payment_875: "750 $ à 999 $",
            opt_rent_mortgage_payment_1250: "1 000 $ à 1 499 $",
            opt_rent_mortgage_payment_1800: "1 500 $ ou plus",
            opt_rent_mortgage_payment_2000: "1 500 $ à 2 499 $",
            opt_rent_mortgage_payment_3000: "2 500 $ ou plus",
            // - insolvency_consultation
            opt_insolvency_consultation_none: "Non, jamais",
            opt_insolvency_consultation_within_6_months: "Oui, au cours des 6 derniers mois",
            opt_insolvency_consultation_over_6_months: "Oui, il y a plus de 6 mois",
            // - product_purpose (business)
            opt_business_purpose_everyday_operations: "Opérations courantes et flux de trésorerie",
            opt_business_purpose_purchase_inventory: "Achat d'inventaire ou de matériaux",
            opt_business_purpose_purchase_new_equipment: "Achat ou réparation d'équipement",
            opt_business_purpose_expansion: "Expansion ou ouverture d'une nouvelle succursale",
            opt_business_purpose_renovations: "Rénovations",
            opt_business_purpose_sales_and_marketing: "Ventes et marketing",
            opt_business_purpose_hire_or_pay_staff: "Embauche ou paie du personnel",
            opt_business_purpose_invest_in_technology: "Investissement en technologie",
            opt_business_purpose_start_a_business: "Démarrage d'une entreprise",
            opt_business_purpose_other: "Autre",
            // - number_of_employees
            opt_number_of_employees_1: "Moi seulement",
            opt_number_of_employees_2_5: "2 à 5",
            opt_number_of_employees_6_10: "6 à 10",
            opt_number_of_employees_11_50: "11 à 50",
            opt_number_of_employees_51_plus: "51 ou plus",
            // - business_type (POS)
            opt_business_type_pos_retail: "COMMERCE DE DÉTAIL",
            opt_business_type_pos_home_improvement: "RÉNOVATION DOMICILIAIRE",
            opt_business_type_pos_powersports: "SPORTS MOTORISÉS",
            opt_business_type_pos_automotive: "AUTOMOBILE",
            opt_business_type_pos_healthcare: "SOINS DE SANTÉ",
            // - asset_type
            opt_asset_type_inventory: "Inventaire",
            opt_asset_type_machinery: "Machinerie",
            opt_asset_type_industrial_equipment: "Équipement industriel",
            opt_asset_type_farming_equipment: "Équipement agricole",
            opt_asset_type_retail_equipment: "Équipement de vente au détail",
            opt_asset_type_restaurant_equipment: "Équipement de restaurant",
            opt_asset_type_it_office_equipment: "Équipement informatique/bureau",
            opt_asset_type_commercial_vehicle: "Véhicule commercial",
            opt_asset_type_tractor: "Tracteur",
            opt_asset_type_forklift: "Chariot élévateur",
            opt_asset_type_excavator: "Excavatrice/Véhicule de construction",
            opt_asset_type_truck: "Gros camion",
            opt_asset_type_other: "Autre actif, veuillez préciser",
            // - payment_processor
            opt_business_payment_processor_chase_paymentech: "CHASE PAYMENTECH",
            opt_business_payment_processor_debitech: "DEBITECH",
            opt_business_payment_processor_desjardins: "DESJARDINS",
            opt_business_payment_processor_elavon: "ELAVON",
            opt_business_payment_processor_everlink: "EVERLINK",
            opt_business_payment_processor_first_data: "FIRST DATA",
            opt_business_payment_processor_global_payments: "GLOBAL PAYMENTS",
            opt_business_payment_processor_mercury_payments: "MERCURY PAYMENTS",
            opt_business_payment_processor_moneris: "MONERIS",
            opt_business_payment_processor_monex: "MONEX",
            opt_business_payment_processor_payfirma: "PAYFIRMA",
            opt_business_payment_processor_pivotal_payments: "PIVOTAL PAYMENTS",
            opt_business_payment_processor_pos_west: "POS WEST",
            opt_business_payment_processor_square: "SQUARE",
            opt_business_payment_processor_stripe: "STRIPE",
            opt_business_payment_processor_td_merchant_services: "TD MERCHANT SERVICES",
            opt_business_payment_processor_other: "AUTRE",
            opt_business_payment_processor_none: "AUCUN",
            // car refinancing
            // own_car
            opt_car_refinancing_own: 'Propriétaire',
            opt_car_refinancing_finance: 'Financé',
            opt_car_refinancing_lease: 'Location',
        },
        placeholders: {
            select: "Sélectionner…",
            your_email: "votre@courriel.com",
            income_type: "Sélectionnez votre principale source de revenus…",
            income_type_other: "Autre (précisez)",
            type_to_search: "Tapez pour rechercher…",
            address_number: "Numéro",
            address_street: "Rue",
            address_unit: "App. 8, bureau 2, etc. (facultatif)",
            address_city: "Ville",
            select_date: "Sélectionner une date...",
            date_format: "AAAA-MM-JJ",
            select_month: "Choisir le mois et l'année",
            // car refinancing
            your_current_lender: 'Votre prêteur actuel'
        },
        textBottom: {
            phone_number_sms_results: '<small style="display: block; font-size: 0.7em; padding-left: 2px; margin-top: -14px;">Vous recevrez un unique SMS avec vos résultats (répondez "STOP" pour arrêter).</small>'
        }
    },
    submissionLoading: {
        searching_providers: 'Recherche des meilleures options...',
        evaluating_options: 'Évaluation de vos options...',
        do_not_refresh: 'Veuillez ne pas actualiser la page',
        almost_there: 'Presque terminé! Recherche des meilleurs résultats pour vous...',
        do_not_leave: 'Veuillez ne pas quitter cette page',
        options_available: 'Bonne nouvelle! Des options sont disponibles dans votre région',
    },
    buttons: {
        more_info: "Plus d'information",
        submit: 'Soumettre',
        skip: "Passer",
        address_not_listed: "Mon adresse ne figure pas dans la liste",
        next: 'Suivant',
        request_code: 'Demander un code',
        request_another_code: 'Demander un autre code',
        edit: 'Modifier'
    }
}
